export default __webpack_public_path__ + "static/griffeye-a7f534a81e120110206cb0024415121e.png";